const KNOWN_INSTRUMENTS = [
  { value: "ES", label: "ES", name: "E-mini S&P 500", family: "sp500" },
  { value: "NQ", label: "NQ", name: "E-mini NASDAQ 100", family: "nasdaq100" },
  { value: "MES", label: "MES", name: "Micro E-mini S&P", family: "sp500" },
  { value: "MNQ", label: "MNQ", name: "Micro E-mini NASDAQ", family: "nasdaq100" },
  { value: "CL", label: "CL", name: "Crude Oil", family: "crude_oil" },
  { value: "MCL", label: "MCL", name: "Micro Crude Oil", family: "crude_oil" },
  { value: "GC", label: "GC", name: "Gold", family: "gold" },
  { value: "MGC", label: "MGC", name: "Micro Gold", family: "gold" },
  { value: "SI", label: "SI", name: "Silver", family: "silver" },
  { value: "SIL", label: "SIL", name: "Micro Silver", family: "silver" },
  { value: "RTY", label: "RTY", name: "E-mini Russell 2000", family: "russell2000" },
  { value: "YM", label: "YM", name: "E-mini Dow Jones", family: "dow" },
  { value: "EURUSD", label: "EUR/USD", name: "EUR/USD", family: "eurusd" },
  { value: "BTCUSD", label: "BTC/USD", name: "BTC/USD", family: "btcusd" },
  { value: "ETHUSD", label: "ETH/USD", name: "ETH/USD", family: "ethusd" },
];

const KNOWN_INSTRUMENT_MAP = new Map(
  KNOWN_INSTRUMENTS.map((instrument) => [instrument.value, instrument]),
);

export const normalizeInstrumentSymbol = (value) => {
  if (!value) return "";
  return String(value).trim().toUpperCase().replace(/[^A-Z0-9/]/g, "");
};

export const getKnownInstrumentCatalog = () => KNOWN_INSTRUMENTS.slice();

export const buildInstrumentOption = (symbol) => {
  const normalized = normalizeInstrumentSymbol(symbol);
  if (!normalized) return null;
  const known = KNOWN_INSTRUMENT_MAP.get(normalized);
  if (known) {
    return { ...known };
  }
  const fxLabel = normalized.endsWith("USD") && normalized.length === 6
    ? `${normalized.slice(0, 3)}/${normalized.slice(3)}`
    : normalized;
  return {
    value: normalized,
    label: fxLabel,
    name: fxLabel,
    family: normalized,
  };
};

export const instrumentFamilyKey = (symbol) => {
  const normalized = normalizeInstrumentSymbol(symbol);
  if (!normalized) return "";
  return buildInstrumentOption(normalized)?.family || normalized;
};

export const findInstrumentFamilyConflict = (symbols = [], nextSymbol) => {
  const normalizedNext = normalizeInstrumentSymbol(nextSymbol);
  if (!normalizedNext) return null;
  const nextFamily = instrumentFamilyKey(normalizedNext);

  for (const currentSymbol of symbols) {
    const normalizedCurrent = normalizeInstrumentSymbol(currentSymbol);
    if (!normalizedCurrent || normalizedCurrent === normalizedNext) continue;
    if (instrumentFamilyKey(normalizedCurrent) !== nextFamily) continue;

    return {
      family: nextFamily,
      existingSymbol: normalizedCurrent,
      nextSymbol: normalizedNext,
      existingOption: buildInstrumentOption(normalizedCurrent),
      nextOption: buildInstrumentOption(normalizedNext),
    };
  }

  return null;
};

export const instrumentOptionsFromSymbols = (symbols = []) => {
  const seen = new Set();
  const options = [];
  for (const symbol of symbols) {
    const option = buildInstrumentOption(symbol);
    if (!option || seen.has(option.value)) continue;
    seen.add(option.value);
    options.push(option);
  }
  return options;
};

export const instrumentOptionsFromBrokerCatalog = (brokers = []) => {
  const symbols = [];
  for (const broker of brokers) {
    if (!Array.isArray(broker?.supported_instruments)) continue;
    symbols.push(...broker.supported_instruments);
  }
  return instrumentOptionsFromSymbols(symbols);
};

export const brokerInstrumentOptions = (supportedInstruments = [], fallback = KNOWN_INSTRUMENTS) => {
  const options = instrumentOptionsFromSymbols(supportedInstruments);
  return options.length ? options : fallback.slice();
};
